import { equalDates, formatDate, formatDateISO } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { FakeButton } from '@stories/Components/Buttons/GeneralButton/Button';
import CategoryPills from '@stories/Components/General/CategoryPills/CategoryPills';
import SvgWheel from '@img/branding-graphics/curves-wheel.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Card.styles';
import brand from '@helpers/brand';
const FeaturedCard = (props) => {
    const HighlightColours = [brand.tertiary.darkBlue, brand.secondary.red];
    const srcs = props.wide
        ? (props.image ? getSrcs(props.image, 449, 346, 3, 270 / 420) : [])
        : (props.image ? getSrcs(props.image, 388, 299, 3, 270 / 420) : []);
    const sizes = props.wide
        ? `${until(Device.DesktopLarge)} 25.5vw, 449px`
        : `${until(Device.DesktopLarge)} 28vw, 449px`;
    /* randomise which colour is used for each wheel */
    const lineColours = HighlightColours.sort(() => Math.random() - 0.5);
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { href: props.cta.url, target: props.cta.target, "data-type": props.type, tabIndex: props.tabIndex },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.ImageInner, null, props.image ? (React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs?.join(','), sizes: sizes, alt: props.image?.altText ?? props.title, loading: 'lazy' })) : (React.createElement(React.Fragment, null,
                    React.createElement(SvgWheel, { style: { '--lineColour': lineColours[0] } }),
                    React.createElement(SvgWheel, { style: { '--lineColour': lineColours[1] } }))))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.ContentInner, null,
                    props.categories || props.date ? (React.createElement(S.TopWrapper, null,
                        props.categories && props.categories.length > 0 ? (React.createElement(S.Pillwrapper, { "data-variant": props.type === 'cta' ? 'dark' : 'light' },
                            React.createElement(CategoryPills, { links: props.categories, tabIndex: props.tabIndex }))) : null,
                        props.date && (React.createElement(S.TimeWrapper, null, !props.endDate ? (React.createElement(S.Time, { dateTime: formatDateISO(props.date) },
                            formatDate(props.date, 'd LLL yyyy'),
                            " |",
                            ' ',
                            formatDate(props.date, 'h:mm a O').replaceAll('+0', ''))) : (React.createElement(React.Fragment, null, equalDates(props.date, props.endDate) ? (React.createElement(S.Time, { dateTime: formatDateISO(props.date) },
                            formatDate(props.date, 'd LLL yyyy'),
                            " |",
                            ' ',
                            formatDate(props.date, 'h:mm a').replaceAll('+0', ''),
                            " -",
                            ' ',
                            formatDate(props.endDate, 'h:mm a O').replaceAll('+0', ''))) : (React.createElement(React.Fragment, null,
                            React.createElement(S.Time, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'd LLL yyyy')),
                            ' ',
                            "-",
                            ' ',
                            React.createElement(S.Time, { dateTime: formatDateISO(props.endDate) }, formatDate(props.endDate, 'd LLL yyyy')))))))))) : null,
                    React.createElement(S.Title, null, props.title),
                    props.subtitle && React.createElement(S.Subtitle, null, props.subtitle),
                    React.createElement(S.Content, null, props.content),
                    props.type === 'cta' ? (React.createElement(FakeButton, { branding: "solid", title: props.cta.text ?? '' })) : (getSvgFromSystem(SystemIcon.ArrowRight)))))));
};
export default FeaturedCard;
